import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const UpgradeCurrentPackageSC = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_60});

  ${MEDIA.MIN_1240} {
    width: 31.5rem;
  }
`
export const BodySC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_30});
`

export const ButtonsSC = styled.div`
  display: flex;
  gap: var(${FIXED_INDENTS.INDENT_50});
  padding: 0 var(${FIXED_INDENTS.INDENT_90});

  ${MEDIA.MIN_600} {
    padding: 0 var(${FIXED_INDENTS.INDENT_60});
    gap: var(${FIXED_INDENTS.INDENT_60});
  }

  ${MEDIA.MIN_1240} {
    padding: 0;
    gap: var(${FIXED_INDENTS.INDENT_20});
  }

  ${ButtonSC} {
    flex: 1;
    padding: var(${FIXED_INDENTS.INDENT_25}) var(${FIXED_INDENTS.INDENT_70});
  }
`

export const OverlaySC = styled.div<{ smallPlayer?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ smallPlayer }) => (smallPlayer ? '100%' : '100dvw')};
  height: ${({ smallPlayer }) => (smallPlayer ? '100%' : '100dvh')};
  background: var(${COLOR.SURFACE_OPACITY_DARK_70});
`
